import { useSEO } from "../components/SEO";
import { PageHero, Reveal } from "../components/Reveal";
import { BookCallButton, BlueprintButton } from "../components/CTA";
import { FunnelVisual } from "../components/FunnelVisual";
import { CtaBand } from "../components/CtaBand";

const STEPS = [
  { title: "Diagnose", text: "Understand the agency, market, offer, current marketing and acquisition problems." },
  { title: "Strategize", text: "Define audience, offer, funnel, channels and campaign direction." },
  { title: "Build", text: "Develop campaigns, creative strategy, landing-page recommendations and lead flows." },
  { title: "Launch", text: "Launch campaigns and begin collecting performance data." },
  { title: "Optimize", text: "Continuously analyze performance and improve weak areas." },
  { title: "Scale", text: "Increase investment into campaigns and channels that demonstrate sustainable performance." },
];

export default function Process() {
  useSEO(
    "Our Process | Nexus Catalyst Agency",
    "A simple six-step growth process for Hajj & Umrah travel agencies in India: Diagnose, Strategize, Build, Launch, Optimize, Scale."
  );

  return (
    <main data-testid="process-page">
      <PageHero
        tag="How It Works"
        testid="process-hero"
        crumbs={[{ label: "How It Works", to: "/how-it-works" }]}
        lines={[
          "A simple process.",
          <>Built around <span className="text-tan">growth.</span></>,
        ]}
        copy="No mystery, no endless onboarding decks. Six deliberate steps that take your agency from scattered marketing to a working acquisition system."
      >
        <BookCallButton testid="process-hero-book-call" />
        <BlueprintButton testid="process-hero-audit" />
      </PageHero>

      <section className="bg-white py-20 md:py-28" data-testid="process-steps">
        <div className="max-w-7xl mx-auto px-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.title}>
              <div
                className="grid md:grid-cols-12 gap-6 md:gap-10 items-baseline py-12 md:py-14 border-t border-charcoal/10"
                data-testid={`process-step-${i + 1}`}
              >
                <div className="md:col-span-3">
                  <span className="text-6xl md:text-7xl font-bold tracking-tighter text-outline select-none">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="md:col-span-3">
                  <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-charcoal">
                    {s.title}
                  </h2>
                </div>
                <div className="md:col-span-6">
                  <p className="text-base text-charcoal/65 leading-relaxed max-w-xl">
                    {s.text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-charcoal/10" />
        </div>
      </section>

      <FunnelVisual />
      <CtaBand
        title="Start With Step One."
        copy="A strategy call is the diagnosis. Bring your current marketing reality. Leave with clarity on the biggest opportunity."
        testid="process-cta-band"
      />
    </main>
  );
}
